import axios from "axios";

import ISonicMessage, {
  SonicMessage,
} from "../../../common/classes/SonicMessage";

import { getChatRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

/**
 * getMessageHistories
 *
 * Fetching chat room messages.
 *
 * @typedof MessageHistory
 * @property {ISonicMessage} message
 * @property {boolean} hasNext Whether the next page of the message
 *
 * @param {string} id id of the room from which the message is to be retrieved.
 * @param {string} auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @param {number} page Number of message pages.
 * @returns {Promise<MessageHistory[] | null>} An array of message histories.
 */

export const getMessageHistories = async (
  id: string,
  auth_token: string,
  page: number
): Promise<{
  messageHistory: Array<ISonicMessage>;
  hasNext: boolean;
} | null> => {
  try {
    const res = await axios.get(getChatRoot(`${APIRoutes.chat.room}/${id}`), {
      headers: {
        "X-Sonic-Auth": auth_token,
      },
      params: {
        page: page,
      },
    });

    if (res.data.result === false) return null;

    const messages: Array<ISonicMessage> = [];

    for (const m of res.data.message.messageHistory) {
      messages.push(SonicMessage.parseFromAPIResponse(m));
    }

    return {
      messageHistory: messages,
      hasNext: res.data.message.hasNext,
    };
  } catch (e) {
    return null;
  }
};
